import { Navigate } from 'react-router-dom'
import FirebaseWorkout from '../components/workout-form/firebase-workout'
import { useUserHasCreateWorkoutPermission } from '../hooks/permissions'

export default function Workout() {
  const createWorkoutPermission = useUserHasCreateWorkoutPermission()
  if (!createWorkoutPermission) {
    return <Navigate to={'/'} />
  }
  return <FirebaseWorkout></FirebaseWorkout>
}
